<template>
  <div class="mobile-contact">
    <!-- 商家入驻 -->
    <div class="message-form">
      <div class="form-title">免费申请试用</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="86px">
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="form.company" placeholder="请输入公司名称" clearable />
        </el-form-item>

        <el-form-item label="所属行业" prop="profession">
          <el-input v-model="form.profession" placeholder="请输入所属行业" clearable />
        </el-form-item>

        <el-form-item label="企业规模" prop="scale">
          <el-input v-model="form.scale" placeholder="请输入企业规模" clearable />
        </el-form-item>

        <el-form-item label="联系人" prop="contract">
          <el-input v-model="form.contract" placeholder="请输入联系人" clearable />
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入电话号码" clearable maxlength="11" />
        </el-form-item>

        <el-form-item label="验证码" prop="code" class="code">
          <el-input v-model.trim="form.code" style="width: 64%" prefix-icon="Lock" placeholder="请输入验证码" :disabled="form.phone == null" />
          <el-button class="login-code" style="width: 36%;height: 40px;padding: 2px 4px;" @click="showCodeDialog" :disabled="form.phone == null || codeTimer > 0">
            {{ codeTimer > 0 ? `${codeTimer}s后重新获取` : '获取验证码' }}
          </el-button>
        </el-form-item>

        <!-- 验证码弹框 -->
        <el-dialog title="请输入验证码" :visible.sync="codeDialogVisible" append-to-body :close-on-click-modal="false">
          <div style="text-align: center;margin-bottom: 20px;">
            <el-image :src="codeUrl" style="width: 150px;height: 40px;cursor: pointer;" @click="handleCode" />
          </div>
          <el-input v-model="dialogParams.code" placeholder="请输入验证码" clearable />
          <span slot="footer">
            <el-button @click="codeDialogVisible = false; dialogParams = {}">取 消</el-button>
            <el-button type="primary" @click="confirmCode">确 定</el-button>
          </span>
        </el-dialog>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱" clearable />
        </el-form-item>

        <el-form-item label="所在地区" prop="region">
          <el-input v-model="form.region" placeholder="请输入所在地区" clearable />
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入详细地址" clearable />
        </el-form-item>
      </el-form>
      <span slot="footer" style="display: flex;justify-content: center;">
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import { getCode, getSendSmsCode, merchantCheckIn  } from '@/api/index'
export default {
  name: 'MobileContact',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        content: ''
      },
      rules: {
        company: { required: true, message: '请输入公司名称', trigger: 'blur' },
        profession:{ required: true, message: '请选择所属行业', trigger: 'change' },
        scale:{ required: true, message: '请选择公司规模', trigger: 'change' },
        contract:{ required: true, message: '请输入联系人', trigger: 'blur' },
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {pattern: /^[1,0][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        code:{ required: true, message: '请输入验证码', trigger: 'blur' },
        email:{ required: true, message: '请输入邮箱', trigger: 'blur' },
        region:{ required: true, message: '请输入所在地区', trigger: 'blur' },
        address:{ required: true, message: '请输入详细地址', trigger: 'blur' },
      },
      loading: false,
      codeUrl: '', // 验证码图片地址
      codeDialogVisible: false, // 验证码弹框显示状态
      codeTimer: 0,
      interval: null,
      dialogParams: {
        phone: null,
        code: null,
        uuid: null
      },
    }
  },
  created() {
  },
  methods: {
    // 获取验证码
    handleCode() {
      getCode().then(res => {
        if(res.code == 200) {
          this.codeUrl = res.img;
          this.dialogParams.uuid = res.uuid;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 显示验证码弹框
    showCodeDialog() {
      this.codeDialogVisible = true
      this.handleCode()
      this.dialogParams.phone = this.form.phone
    },

    // 确认验证码
    confirmCode() {
      if (!this.dialogParams.code) {
        this.$message.warning('请输入验证码')
        return
      }
      this.codeDialogVisible = false
      this.getSmsCode()
      this.dialogParams = {}
    },

    // 获取短信验证码
    getSmsCode() {
      getSendSmsCode(this.dialogParams).then(res => {
        if(res.code == 200) {
          this.$message.success('验证码已发送')
          this.startTimer()
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    startTimer() {
      if (this.codeTimer > 0) return
      // 先开始倒计时
      this.codeTimer = 60
      this.interval = setInterval(() => {
        if (this.codeTimer > 0) {
          this.codeTimer--
        } else {
          clearInterval(this.interval)
        }
      }, 1000)
    },
    // 提交
    submit(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          merchantCheckIn(this.form).then(res => {
            if(res.code === 200)  {
              this.$message({
                type: 'success',
                message: '提交成功'
              });
              this.open = false;
              // this.open2 = true
              this.$refs['form'].resetFields();
            } else {
              this.$message({
                type: 'error',
                message: '提交失败'
              });
            }
          });
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.mobile-contact {
  padding: 15px;
}

.message-form {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);

  .form-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 4px solid #2c9dcf;
  }

  :deep(.el-input__inner) {
    height: 40px;
    line-height: 40px;
  }

  :deep(.el-textarea__inner) {
    min-height: 120px;
  }

  .submit-btn {
    width: 100%;
    height: 40px;
  }
}

.map-container {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);

  .map-iframe {
    width: 100%;
    height: 300px;
  }
}
</style>
